<template>
  <v-container fluid style="height: 100%" class="pa-0 ma-0">
    <div v-if="loading" class="d-flex align-center justify-center" style="height: 200px;">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <template v-else-if="supplier">
      <div class="header">
        <strong>{{ supplier.supplier_name }}</strong>
      </div>
      <v-col cols="12" class="ma-0 pa-0">
        <v-tabs centered v-model="tab">
          <v-tab href="#tab-1" class="tabs">Setup</v-tab>
          <v-tab href="#tab-2" class="tabs">Products</v-tab>
          <v-tab href="#tab-3" class="tabs">Unavailable Dates</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <Setup :supplier="supplier" @updated="fetchSupplier" />
          </v-tab-item>
        </v-tabs-items>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-2">
            <Product :supplier-id="supplier.id" />
          </v-tab-item>
        </v-tabs-items>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-3">
            <Unavailability :supplier-id="supplier.id" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </template>
  </v-container>
</template>

<script>
import Setup from './tabs/SupplierDetailsTab.vue'
import Product from './tabs/ProductsTab.vue'
import Unavailability from './tabs/UnavailabilityTab.vue'

export default {
  components: { Setup, Product, Unavailability },
  data: () => ({
    tab: null,
    supplier: null,
    loading: false,
  }),
  async mounted() {
    await this.fetchSupplier()
  },
  methods: {
    // Called by the AI Assistant after it changes data: reload the supplier in place
    aiRefresh() {
      return this.fetchSupplier()
    },
    async fetchSupplier() {
      this.loading = true
      const { data } = await this.$axios.get(`admin/suppliers/get_supplier/${this.$route.params.supplier_id}`)
      if (data.response) {
        this.supplier = data.data
        document.title = `${this.supplier.supplier_name} - GGB`
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  max-width: 100%;
  height: 50px;
  text-align: center;
  position: relative;
  z-index: 1;
  line-height: 50px;
}

.tabs {
  text-transform: none !important;
}
</style>
